module.exports = __webpack_public_path__ + "static/media/black-gradient-rotated.693a1835.png";